<template>
  <z-simple-card-template
    class="zoox-component zoox-initial-template"
    :title="title"
    :description="description"
    :align="align"
  >
    <template #content>
      <z-scrollbar>
        <div
          :style="{
            paddingLeft: `${paddingLeft}%`,
            paddingRight: `${paddingRight}%`,
          }"
          class="template-options"
        >
          <template v-for="(chunk, index) of chunkedOptions">
            <div
              v-if="mustDrawDivider(index)"
              :key="'chunk' + index"
              class="template-divider"
            ></div>
            <template v-for="option of chunk">
              <slot :name="'option-' + option.index">
                <z-card
                  :key="option.index"
                  width="100%"
                  @click="$emit('click', option)"
                >
                  <template #content>
                    <div class="template-option">
                      <div
                        class="template-option-icon"
                        :style="{
                          background: option.color || getColor(option.index),
                        }"
                      >
                        <z-icon dark :size="defineIconSize">
                          {{ option.icon }}</z-icon
                        >
                      </div>
                      <div class="template-option-content">
                        <div class="item-title body-bold">
                          {{ option.title }}
                        </div>
                        <div class="item-description body-text">
                          {{ option.description }}
                        </div>
                      </div>
                    </div>
                  </template>
                </z-card>
              </slot>
            </template>
          </template>
        </div>
      </z-scrollbar>
    </template>
  </z-simple-card-template>
</template>

<script>
import chunk from 'lodash.chunk'

const COLORS = [
  'lightblue',
  'magenta',
  'orange',
  'yellow',
  'darkgreen',
  'purple',
]

/**
 * Initial template é um template de página que deve ser
 * utilizado ao fazer apresentações de um produto, ou um conjunto de módulos.
 *
 * @displayName Initial Template
 */
export default {
  name: 'ZInitialTemplate',
  props: {
    /**
     * Título da página
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Descrição das opções da página
     */
    description: {
      type: String,
      default: '',
    },
    /**
     * Opções colocadas na página.
     *
     * @typedef Object {title: string, description: string, icon: string, color: string}
     */
    options: {
      type: Array,
      default: () => [],
    },
    /**
     * Array de números indicando onde deve ficar o
     * divider
     */
    dividers: {
      type: Array,
      default: () => [],
    },
    /**
     * Alinhamento do título e da descrição
     * no card
     *
     * @values center,start,end
     */
    align: {
      type: String,
      default: '',
    },
    /**
     * Define o padding esquerdo das options
     */
    paddingLeft: {
      type: Number,
      required: false,
      default: 15,
    },
    /**
     * Define o padding direito das options
     */
    paddingRight: {
      type: Number,
      required: false,
      default: 15,
    },
  },
  computed: {
    chunkedOptions() {
      const options = this.options.map((option, index) => ({
        ...option,
        index,
      }))

      return chunk(options, 2)
    },
    defineIconSize() {
      return this.$vuetify.breakpoint.width >= 800 ? '72' : '32'
    },
  },
  methods: {
    getColor(index) {
      return this.$zoox.colors[COLORS[index % COLORS.length]]
    },
    mustDrawDivider(index) {
      return this.dividers.some((dividerIndex) => dividerIndex === index)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-initial-template {
  display: grid;
  place-items: center;
  .ps {
    display: grid;
    align-items: center;
    height: calc(100vh - 200px);
  }
}

.template-options {
  display: grid;
  place-items: center;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
}

.template-divider {
  grid-column: 1 / -1;
  width: 100%;
  height: 1px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.template-option {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 27px;

  .template-option-content {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
  }
}

.template-option-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: grid;
  place-items: center;
}

@media screen and (max-width: 768px) {
  .template-options {
    grid-template-columns: 1fr;
    .template-option-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: grid;
      place-items: center;
    }
  }
}
</style>
